import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * @type {{
 *   isInitialized: () => Promise<{ initialized: boolean }>,
 *   register: () => Promise<{ fcmToken: string }>
 * }}
 */
export const FirebaseMessaging = registerPlugin('FirebaseMessaging');

export const isFirebaseInitialized = async () => {
  if (Capacitor.getPlatform() === 'web') return false;

  // Bridge failures reject so the session workflow can report registration failure.
  const result = await FirebaseMessaging.isInitialized();
  return result?.initialized === true;
};
